import $ from 'jquery';

const getQueryParams = () => {
    const dedupedFields = $('[data-filter-form]')
        .find('input, textarea, select')
        .filter((_, item) => $(item).val() !== '')
        .serializeArray()
        .reduce((deduped, field) => {
            deduped[field.name] = field;
            return deduped;
        }, {});

    // returns an array equivalent to Object.values
    return Object.keys(dedupedFields).map(key => {
        return dedupedFields[key];
    });
};

export const getQueryParamsAsObject = () => {
    return getQueryParams().reduce((obj, item) => {
        return {
            ...obj,
            [item.name]: item.value,
        };
    }, {});
};

export default getQueryParams;



// WEBPACK FOOTER //
// ./src/web/js/browse/data/getQueryParams.js